// API Docs: https://github.roving.com/pages/contacts/api-dashboard/#/

import { getEnv } from '@ctct/ctct-helpers';

import { Status } from './types/contact.types';
import { BaseApiClient } from '../BaseApiClient';

class ContactSvcApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/contacts`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getContactsCount(limit = 0, status = Status.ACTIVE, includeCount = true) {
    return this.baseApiClient.get<unknown>('/contacts', {
      limit,
      status,
      include_count: includeCount,
    });
  }
}

export const contactSvcApi = new ContactSvcApi();
